module.exports = __webpack_public_path__ + "static/logo-378adbda9eb0d89cfe448114b8617714.svg";